<template>
    <v-flex>
        <div class="terms_wrap">
        <h5 class="font-weight-bold" style="text-align:center; font-size: 1.25rem;">무료보험 가입 동의</h5>
        <br />
        <p>
          핀브릿지 주식회사(이하 "회사"라 한다)는 세이프가드 서비스(이하 "서비스"라 한다)의 유료고객을 대상으로 
          무료단체보험(피싱∙해킹 금융사기보상보험)을 제공합니다. 이를 위하여 다음의 사항에 대하여 동의를 받습니다.
        </p>
        <br />
        <p><strong>무료단체보험 가입동의</strong></p>

        <p>
          피싱∙해킹 금융사기보상보험은 서비스 이용요금과 무관한 단체보험이며, 
          회사가 대표로 보험사와 단체보험계약을 체결합니다. 단체보험의 보험료는 전액 회사가 부담하고, 
          보험한도액은 사고율에 따라 증감될 수 있으며 단체보험계약이 철회될 수 있습니다.
        </p>
        <br />
        <p><strong>개인정보수집 및 이용동의</strong></p>
        <p>
          회사는 무료단체보험을 제공하기 위하여 아래의 개인정보를 수집 및 이용합니다.
        </p>
        <p>
          - 목적 : 금융사기보상신청 처리
        </p>
        <p>
          - 개인정보항목 : 휴대폰번호, 성명, 생년월일, 성별
        </p>
        <p>
          <span class="accent">- 보유기간 : 서비스 가입 일부터 해지 후 3년</span>
        </p>
        <br />
        <p><strong>개인정보 제3자 제공동의</strong></p>
        <p>
          회사는 무료단체보험을 제공하기 위하여 아래와 같이 개인정보를 제3자에게 제공합니다.
        </p>
        <p>
          <span class="accent">- 제공받는 자 : 신한ez손해보험 주식회사</span>
        </p>
        <p>
          <span class="accent">- 이용목적 : 보험료 정산 및 보상처리</span>
        </p>
        <p>
          - 제공받는 개인정보 항목 : 성명, 휴대폰번호
        </p>
        <p>
          <span class="accent">- 제공받는 자의 개인정보 보유기간 : 서비스 가입일부터 해지 후 3년</span>
        </p>
        <br />
        <p><strong>KT개인정보 제3자 제공동의</strong></p>
        <p>
          (주)케이티는 세이프가드 서비스의 원활한 제공을 위하여 다음과 같은 정보를 회사에 제공합니다.
        </p>
        <p>
           <span class="accent">- 제공받는 자 : 핀브릿지 주식회사</span>
        </p>
        <p>
           <span class="accent">- 이용목적 : 금융사기보상신청 처리</span>
        </p>
        <p>
          - 제공받는 개인정보 항목 : 휴대폰번호, 성명, 생년월일, 성별
        </p>
        <p>
           <span class="accent">- 제공받는 자의 개인정보 보유기간 : 서비스 가입 일부터 해지 후 3년</span>
        </p>
        <br />
        <p>
          * 단, 법령에 정해진 개인정보 보유기간이 있을 경우 그에 따릅니다.
        </p>
        <p>
          ** 회사 및 (주)케이티는 서비스 제공을 위하여 필요한 최소한의 정보만을 수집∙이용∙제공하고 있으며, 이에 대한 동의가 없을 경우에도 세이프가드 서비스를 이용할 수 있습니다. 다만, 세이프가드 서비스에서 제공하는 무료단체보험의 가입 및 이용이 불가능합니다.
        </p>
      </div>
  </v-flex>
</template>
<script>
export default {
  data() {
    return {
      newTerms: true,
    };
  },
  mounted() {
    window.onClickTitleCloseBtn = this.onClickTitleCloseBtn;
  },
  methods: {
    // WebView타이틀의 왼쪽버튼(X 또는 <) 액션 전달
    onClickTitleCloseBtn: function() {
      this.$router.go(-1);
    },
  },
}
</script>
<style scoped>
.terms_wrap{
  padding: 5px 5px !important;
}
/* 약관 강조 */
.accent {
  text-decoration: underline;
  font-weight: bold;
  font-size: 120%;
  background-color: white !important;
}
@media screen and (max-width: 338px) {
  .font-weight-bold {
    font-size: 1.1rem !important;
  }
}
</style>
